import { createStore } from 'vuex'
import user from './modules/user'
import app from './modules/app'
import menu from './modules/menu'

export default createStore({
  modules: {
    user,
    app,
    menu
  }
})
